import { BetslipUtilChannels } from "../dependencies";
import { LibConfig } from "../config";
/*
    ToDo: Delete this file when racing(horse racing/greyhounds) and virtual sport blocks are migrated to SD
    purpose of this file is backward compatibility between legacy blocks and new betslip based on APIs
*/
/*istanbul ignore file*/
/* tslint:disable */
export function BetSlipUtilExtend() {
    window["$"].extend(window["BetSlipUtil"], (function () {
        let api = {};
        function transformPoints(points) {
            return points < 0 ? Math.ceil(points) : Math.floor(points);
        }
        ;
        function createQAHRMsgItem(qaBetParams) {
            var event = qaBetParams.event, line = qaBetParams.line;
            return {
                eventId: getSDEventId(qaBetParams.racecardEventId, event.ID),
                marketId: getSDMarketId(line.LineTypeID, true, event.ID, event.TypeID),
                selectionId: getSDQASelectionId(event.ID, line.ID, line.LineTypeID, event.LeagueID, line.QATypeParameter1, line.QATypeParameter2),
                sportId: event.BranchID.toString(),
                type: "Regular",
                alternativeSelections: line.AlternativeLineID ? [{
                        id: getSDQASelectionId(event.ID, line.AlternativeLineID, line.AlternativeLineTypeID, event.LeagueID, line.AlternativeLineQATypeParameter1, line.AlternativeLineQATypeParameter2)
                    }] : undefined
            };
        }
        function getMsgItemChannel(item) {
            let selection = api.getSelections().items.find(sel => sel &&
                sel.marketId === item.marketId &&
                sel.eventId === item.eventId &&
                sel.selectionId === item.selectionId &&
                sel.type === "Regular");
            return selection
                ? BetslipUtilChannels.Listen.Commands.remove_items
                : BetslipUtilChannels.Listen.Commands.add_items;
        }
        ;
        function getSDEventId(masterEventId, eventId) {
            return masterEventId ? masterEventId.toString() : eventId.toString();
        }
        function getSDMarketId(lineTypeId, isQA, eventId, eventTypeId) {
            if ((lineTypeId === 1 || lineTypeId === 2 || lineTypeId === 3 && !isQA)
                || eventTypeId === 769) {
                return `${lineTypeId}_${eventId}`;
            }
            return eventId.toString();
        }
        ;
        function getSDRegularSelectionId(eventId, lineTypeId, rowTypeId, points) {
            let pointsTransform = transformPoints(Math.abs(points * 100));
            switch (lineTypeId) {
                case 1:
                    return `0ML${eventId}_${rowTypeId}`;
                case 2:
                    return `0HC${eventId}${points < 0.0 ? "N" : "P"}${pointsTransform}_${rowTypeId}`;
                case 3:
                    return `0OU${eventId}${rowTypeId === 3 ? "U" : "O"}${pointsTransform}_${rowTypeId}`;
                default:
                    return `0UNK${eventId}${points < 0.0 ? "N" : "P"}${pointsTransform}_${rowTypeId}`;
            }
        }
        ;
        function getQAParam(qaparam) {
            if (qaparam !== undefined) {
                return qaparam;
            }
            return -1;
        }
        ;
        function getSDQASelectionId(eventId, lineId, lineTypeId, leagueId, qaparam1, qaparam2) {
            return `0QA${eventId}#${lineId}_${lineTypeId}L${leagueId}Q1${getQAParam(qaparam1)}Q2${getQAParam(qaparam2)}`;
        }
        ;
        function getCastMessageItem(event, lineId, pos, type) {
            let line = event.Lines[lineId];
            return {
                eventId: event.ID.toString(),
                marketId: event.ID.toString(),
                selectionId: getSDQASelectionId(event.ID, line.ID, line.LineTypeID, event.LeagueID, line.QATypeParameter1, line.QATypeParameter2),
                racingCastBetPosition: pos,
                type,
                sportId: event.BranchID.toString()
            };
        }
        api.getSelections = function () {
            return LibConfig.betslip.getSelections();
        };
        api.isOddInSlip = function (masterEventID, eventID, lineID, lineGroupID, rowTypeID, lineTypeID, isLive, isQA, points, eventTypeId, qaParam1, qaParam2, leagueID) {
            let selectionId = "";
            let marketId = getSDMarketId(lineTypeID, isQA, eventID, eventTypeId);
            let eventId = getSDEventId(masterEventID, eventID);
            if (isQA) {
                selectionId = getSDQASelectionId(eventID, lineID, lineTypeID, leagueID, qaParam1, qaParam2);
            }
            else {
                selectionId = getSDRegularSelectionId(eventID, lineTypeID, rowTypeID, points);
            }
            let selection = api.getSelections().items.find(sel => sel &&
                sel.marketId === marketId &&
                sel.eventId === eventId &&
                sel.selectionId === selectionId &&
                sel.type === "Regular");
            return selection
                ? true
                : false;
        };
        api.createQAOddHRParams = function (event, line, racecardEventId) {
            return {
                event: {
                    ID: event.ID,
                    TypeID: event.Type,
                    LeagueID: event.LeagueID,
                    BranchID: event.BranchID,
                    RaceProgress: event.RaceProgress
                },
                line: {
                    ID: line.ID,
                    LineTypeID: line.LineTypeID,
                    QATypeParameter1: line.QATypeParameter1,
                    QATypeParameter2: line.QATypeParameter2,
                    Odds: line.Odds,
                    AlternativeLineID: line.AlternativeLineId,
                    AlternativeLineTypeID: line.AlternativeLineTypeId,
                    AlternativeLineQATypeParameter1: line.AlternativeLineQATypeParameter1,
                    AlternativeLineQATypeParameter2: line.AlternativeLineQATypeParameter2
                },
                racecardEventId: racecardEventId
            };
        };
        api.addQAOddHRMsgItem = function (qaBetParams) {
            var item = createQAHRMsgItem(qaBetParams);
            return LibConfig.internalMsgBus.emit(getMsgItemChannel(item), {
                receiverIds: [],
                items: [item]
            });
        };
        api.sendQAOddHRMsgItem = function (event, line, racingRegionId) {
            const item = createQAHRMsgItem({ event, line, racingRegionId });
            return LibConfig.internalMsgBus.emit(getMsgItemChannel(item), {
                receiverIds: [],
                items: [item]
            });
        };
        api.sendQACastMsgItems = function (event) {
            if (!event) {
                return false;
            }
            if (!event.canPlaceForecastBet()) {
                return false;
            }
            const items = [
                ...Object.entries(event.ForecastSelection)
                    .map(([lineID, pos]) => getCastMessageItem(event, lineID, pos, "Forecast")),
                ...Object.entries(event.TricastSelection)
                    .map(([lineID, pos]) => getCastMessageItem(event, lineID, pos, "Tricast"))
            ];
            LibConfig.internalMsgBus.emit(BetslipUtilChannels.Listen.Commands.add_items, {
                receiverIds: [],
                items
            });
            return true;
        };
        api.getSDMarketId = function (selection) {
            return getSDMarketId(selection.BetTypeID, !selection.IsRegular, selection.EventID, selection.EventTypeID);
        };
        api.getSDEventId = function (selection) {
            return getSDEventId(selection.MasterEventID || selection.RaceCardEventID, selection.EventID);
        };
        api.getSDSelectionId = function (selection) {
            if (selection.IsRegular) {
                return getSDRegularSelectionId(selection.EventID, selection.LineTypeID, selection.BetSide, selection.Points);
            }
            return getSDQASelectionId(selection.EventID, selection.LineID, selection.LineTypeID, selection.LeagueID, getQAParam(selection.QAParam1), getQAParam(selection.QAParam2));
        };
        return api;
    }()));
}
;
window["isFullBetslip"] && BetSlipUtilExtend();
//# sourceMappingURL=betslipUtilExtend.js.map